module ContentEditableDivRange {
  export function construct() {
    $("tbody tr div[contenteditable=true]").keyup(handleContentEditableDivChanged);
  }

  function handleContentEditableDivChanged(event: JQuery.Event<HTMLElement, null>) {
    const changedDiv = $(this);

    if (!ContentEditableDiv.getIfDivChanged(changedDiv)) {
      return;
    }

    const selectedCells = TableRangeSelection.getSelectedCells(changedDiv);
    if (selectedCells == null) {
      return;
    }
    const newValue = changedDiv.html();

    selectedCells.forEach(function (td) {
      const div = td.find("div[contenteditable=true]");
      if (!div.is(changedDiv)) {
        div.html(newValue);
        const backingInput = ContentEditableDiv.getBackingInput(div);
        backingInput.change();
      }
    });
  }
}

$(document).ready(() => {
  ContentEditableDivRange.construct();
});